import { render } from "./combo.vue?vue&type=template&id=e20266d2&scoped=true"
import script from "./combo.vue?vue&type=script&lang=js"
export * from "./combo.vue?vue&type=script&lang=js"

import "./combo.vue?vue&type=style&index=0&id=e20266d2&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20266d2"]])

export default __exports__